export default __webpack_public_path__ + "cfa51ad432588e2ac8ba83186a131c3c.png";